import { useState, useEffect, useCallback } from 'react';
import { BarcodeType2LookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.ts';

interface UseBarcodeType2LookupResult {
  barcodeType2s: BarcodeType2LookupItem[];
  loading: boolean;
  error: string | null;
  fetchBarcodeType2s: () => Promise<void>;
}

export const useBarcodeType2Lookup = (): UseBarcodeType2LookupResult => {
  const [barcodeType2s, setBarcodeType2s] = useState<BarcodeType2LookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBarcodeType2s = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: BarcodeType2LookupItem[] }>('/barcode_2', { allPages: true });
      setBarcodeType2s(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch Barcode Type 2s: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching Barcode Type 2s.');
      }
      setBarcodeType2s([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBarcodeType2s();
  }, [fetchBarcodeType2s]);

  return {
    barcodeType2s,
    loading,
    error,
    fetchBarcodeType2s,
  };
};